export default (theme) => ({
    root: {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        transition: 'opacity 0.5s',
        willChange: 'opacity',
        zIndex: 1010,
    },
    overlay: {},
    header: {
        position: 'relative',
        height: 50,
        width: '100%',
        boxSizing: 'border-box',
        padding: '0 20px',
        backgroundColor: theme.colors.grey[700],
        display: 'flex',
        justifyContent: 'space-between',
    },
    contentLeft: {
        height: '100%',
    },
    contentCenter: {
        height: '100%',
    },
    contentRight: {
        height: '100%',
        display: 'flex',
    },
    close: {
        height: 18,
        width: 18,
        alignSelf: 'center',
        cursor: 'pointer',
        '& path': {
            transition: '.3s',
        },
        '&:hover path': {
            fill: theme.colors.primary.white,
        },
    },
    icon: {
        height: 18,
        width: 18,
        alignSelf: 'center',
        cursor: 'pointer',
    },
    divider: {
        height: 18,
        width: 'auto',
        margin: '0 20px',
        alignSelf: 'center',
    },
});
